import axios from 'axios';
import Forms from './form';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';

export default class Suporte {
    constructor() {
        this.loading = document.querySelector('.modalLoading');
        this.containerForm = document.querySelector('.container--form');
        this.form = document.querySelector('#formSuporte');
        this.formFields = this.form.querySelectorAll('input, select, textarea');
        this.errorForm = document.getElementById('erroSuporte');
        this.sucessoForm = document.getElementById('sucessoSuporte');
        this.produtoField = document.querySelector('#dropdown-empreendimentos');

        this.initTextareaCounter(
            '#desSolicitacao',
            '#desSolicitacaoCounter'
        );

        this.ready();
    }

    ready() {
        const cpfCnpjField = this.form.querySelectorAll(".cpfCnpjMask");
        const phoneField = this.form.querySelectorAll(".telMask");
        const dateField = this.form.querySelectorAll(".dateMask");
        Forms.masks(phoneField, dateField, cpfCnpjField, 'CPF');

        this.activeSelectTipoDocumento();
        this.populateEmpreendimentos();

        new Bouncer(`#formSuporte`, {
            fieldClass: 'error-field',
            disableSubmit: true,
            ...Forms.wrongMessages(),
        });

        document.addEventListener('bouncerShowError', (event) => {
            let hasIdLocalValue = false;
            let hasIdUnidadeValue = false;
            const idLocalField = this.form.querySelector('#idLocal');
            const idUnidadeField = this.form.querySelector('#idUnidade');
            const ddSelectEmpreendimento = document.querySelector('#dropdown-get-empreendimentos');
            const ddSelectUnidades = document.querySelector('#dropdown-get-unidades');

            if (idLocalField && idLocalField.value) {
            hasIdLocalValue = true;
            ddSelectEmpreendimento?.classList.remove('error-field');
            } else {
            ddSelectEmpreendimento?.classList.add('error-field');
            }
            if (idUnidadeField && idUnidadeField.value) {
            hasIdUnidadeValue = true;
            ddSelectUnidades?.classList.remove('error-field');
            } else {
            ddSelectUnidades?.classList.add('error-field');
            }

            this.formFields.forEach(field => {
            if (field.classList.contains('error-field') || !hasIdLocalValue || !hasIdUnidadeValue) {
                this.errorForm.classList.remove('noShow');
                this.errorForm.scrollIntoView({ behavior: 'smooth' });
            }
            });
        }, false);

        this.form.addEventListener('bouncerFormValid', (event) => {
            event.preventDefault();
            const idLocalField = this.form.querySelector('#idLocal');
            const idUnidadeField = this.form.querySelector('#idUnidade');
            // Não envia se algum id está vazio
            if (!idLocalField?.value || !idUnidadeField?.value) {
                this.errorForm.classList.remove('noShow');
                this.errorForm.scrollIntoView({ behavior: 'smooth' });
                return;
            }
            if (event.target.id === this.form.id) {
            this.sendForm(event.target);
            }
        }, false);
    }

    activeSelectTipoDocumento() {
        const ddSelectTipo = document.querySelector('#dropdown-tipo-documento');
        const spanSelectTipo = document.querySelector('#textTipo');
        const dropdownList = ddSelectTipo?.querySelector('.dropdown-list');
    
        if (ddSelectTipo && !ddSelectTipo.dataset.bound) {
    
            ddSelectTipo.addEventListener('click', (evt) => {
                if (!evt.target.closest('a')) {
                    ddSelectTipo.classList.toggle('is-active');
                }
            });
    
            dropdownList.addEventListener('click', (evt) => {
                const link = evt.target.closest('a');
                if (link) {
                    spanSelectTipo.innerHTML = link.textContent;
                    const cpfCnpjField = this.form.querySelectorAll(".cpfCnpjMask");
                    const phoneField = this.form.querySelectorAll(".telMask");
                    const dateField = this.form.querySelectorAll(".dateMask");
                    Forms.masks(phoneField, dateField, cpfCnpjField, link.dataset.value);
                    ddSelectTipo.classList.remove('is-active');
                }
            });
    
            ddSelectTipo.dataset.bound = "true";
        }
    }

    populateEmpreendimentos() {
        this.loading.classList.add('active');
        axios.get(url + '/ajax/get_empreendimentos.php')
            .then(response => {
                const empreendimentos = response.data.obras;
                const dropdownList = this.form.querySelector('#dropdown-get-empreendimentos .dropdown-list');
                dropdownList.innerHTML = '';

                empreendimentos.sort((a, b) => a.nome.localeCompare(b.nome));
                empreendimentos.forEach(empreendimento => {
                    dropdownList.appendChild(this.templateSelect(empreendimento.id, empreendimento.nome));
                });

                this.activeSelectEmpreendimentos();
                this.loading.classList.remove('active');
            })
            .catch(error => {
                console.error('Erro ao buscar empreendimentos:', error);
                this.loading.classList.remove('active');
            });
    }

    activeSelectEmpreendimentos() {
        const ddSelectEmpreendimento = document.querySelector('#dropdown-get-empreendimentos');
        const spanSelectEmpreendimento = document.querySelector('#textEmpreendimento');
        const dropdownList = ddSelectEmpreendimento?.querySelector('.dropdown-list');
    
        if (ddSelectEmpreendimento && !ddSelectEmpreendimento.dataset.bound) {
    
            ddSelectEmpreendimento.addEventListener('click', (evt) => {
                if (!evt.target.closest('a')) {
                    ddSelectEmpreendimento.classList.toggle('is-active');
                }
            });
    
            dropdownList.addEventListener('click', (evt) => {
                const link = evt.target.closest('a');
                if (link) {
                    spanSelectEmpreendimento.innerHTML = link.textContent;
                    this.form.querySelector('#idLocal').value = link.dataset.value;
                    this.form.querySelector('#nomeLocal').value = link.textContent;
                    this.populateUnidades(link.dataset.value);
                    ddSelectEmpreendimento.classList.remove('is-active');
                }
            });
    
            ddSelectEmpreendimento.dataset.bound = "true";
        }
        ddSelectEmpreendimento.classList.remove('error-field');
    }
    
    populateUnidades(idObra) {
        this.loading.classList.add('active');
        axios.get(url + '/ajax/get_unidades.php?idObra=' + idObra)
            .then(response => {
                const locais = response.data.locais;
                const dropdownList = this.form.querySelector('#dropdown-get-unidades .dropdown-list');
                dropdownList.innerHTML = '';

                locais.sort((a, b) => {
                    const numA = a.codLocal.split('.').map(Number);
                    const numB = b.codLocal.split('.').map(Number);
                    for (let i = 0; i < Math.max(numA.length, numB.length); i++) {
                        const valA = numA[i] || 0;
                        const valB = numB[i] || 0;
                        if (valA !== valB) return valA - valB;
                    }
                    return 0;
                });

                locais.forEach(local => {
                    dropdownList.appendChild(this.templateSelect(local.id, local.nome));
                });

                this.activeSelectUnidades();
                this.loading.classList.remove('active');
            })
            .catch(error => {
                console.error('Erro ao buscar unidades do empreendimento:', error);
            });
    }

    activeSelectUnidades() {
        const ddSelectUnidades = document.querySelector('#dropdown-get-unidades');
        const spanSelectUnidades = document.querySelector('#textUnidades');
        const dropdownList = ddSelectUnidades?.querySelector('.dropdown-list');
    
        if (ddSelectUnidades && !ddSelectUnidades.dataset.bound) {
            spanSelectUnidades.innerHTML = 'Selecione a unidade';
    
            ddSelectUnidades.addEventListener('click', (evt) => {
                if (!evt.target.closest('a')) {
                    ddSelectUnidades.classList.toggle('is-active');
                }
            });
    
            dropdownList.addEventListener('click', (evt) => {
                const link = evt.target.closest('a');
                if (link) {
                    spanSelectUnidades.innerHTML = link.textContent;
                    this.form.querySelector('#idUnidade').value = link.dataset.value;
                    this.form.querySelector('#nomeUnidade').value = link.textContent;
                    ddSelectUnidades.classList.remove('is-active');
                }
            });

            ddSelectUnidades.classList.remove('error-field');
    
            ddSelectUnidades.dataset.bound = "true";
        }
    }

    templateSelect(id, nome) {
        const listItem = document.createElement('li');
        const link = document.createElement('a');
        link.href = 'javascript:void(0);';
        link.dataset.value = id;
        link.textContent = nome;
        listItem.appendChild(link);
        return listItem;
    }

    sendForm(form) {
        this.loading.classList.add('active');

        const formData = new FormData(form);
        formData.append('dataAberturaSolicitacao', new Date().toISOString());

        const fileInput = this.form.querySelector('input[type="file"]');
        if (fileInput && fileInput.files.length > 0) {
            Array.from(fileInput.files).forEach((file) => {
                formData.append('anexos[]', file);
            });
        }

        axios.post(url + '/ajax/abre_solicitacao.php', formData)
            .then(response => {
                if (response.data.idRequest) {
                    console.log('Formulário enviado com sucesso:', response.data);
                    form.reset();
                    this.errorForm.classList.add('noShow');
                    this.sucessoForm.classList.remove('noShow');
                } else {
                    console.error('Erro ao enviar formulário:', response.data.message);
                    this.sucessoForm.classList.add('noShow');
                    this.errorForm.classList.remove('noShow');
                }
                this.loading.classList.remove('active');
                this.containerForm.scrollIntoView({ behavior: 'smooth' });
            })
            .catch(error => {
                console.error('Erro ao enviar formulário:', error);
                this.errorForm.classList.remove('noShow');
                this.loading.classList.remove('active');
                this.containerForm.scrollIntoView({ behavior: 'smooth' });
            });
    }

    initTextareaCounter(textareaSelector, counterSelector) {
        const textarea = document.querySelector(textareaSelector);
        const counter = document.querySelector(counterSelector);

        if (!textarea || !counter) return;

        const maxLength = parseInt(textarea.getAttribute('maxlength'), 10);

        const updateCounter = () => {
            const remaining = maxLength - textarea.value.length;
            counter.textContent = remaining >= 0 ? remaining : 0;
        };

        // Atualiza ao digitar, colar, apagar etc
        textarea.addEventListener('input', updateCounter);

        // Inicializa ao carregar
        updateCounter();
    }
}
